// @ts-nocheck
// 该文件由 kmi 自动生成
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { getPluginManager } from '@@/core/plugin';

const KMI_CLIENT_RENDER_REACT_PLUGIN_LIST = [
  'innerProvider',
  'i18nProvider',
  'accessProvider',
  'dataflowProvider',
  'outerProvider',
  'rootContainer',
];

const KmiProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const pluginManager = getPluginManager();

  let rootContainer = <>{children}</>;

  // 加载所有需要的插件
  for (const key of KMI_CLIENT_RENDER_REACT_PLUGIN_LIST) {
    rootContainer = pluginManager.applyPlugins({
      type: 'modify',
      key: key,
      initialValue: rootContainer,
      args: {
        pluginManager,
      },
    });
  }

  return <>{rootContainer}</>;
};

export {
  KmiProvider
};